export const save = (name, data) => localStorage.setItem(name, JSON.stringify(data));
export const remove = (name) => localStorage.removeItem(name);
export const load = (name) => JSON.parse(localStorage.getItem(name));
